<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button @click="cerrarModal({recargar: true});">
          <ion-icon slot="icon-only"  name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>
        <span v-if="propEvento.grupo == 1">Falla masiva</span>
        <span v-else>{{ 'Ticket '+propEvento.evt_id }}</span>
      </ion-title>
      <ion-buttons v-if="tipoUsuario == 1" slot="end">
        <ion-button @click="muestraAlertEliminar();">
          <ion-icon slot="icon-only"  name="trash-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <ion-toolbar v-if="propEvento.grupo == 1">
      <div v-if="!cargando" class="segment-tabs">
        <div v-for="(evento_m,index) in eventosGrupo" :key="index+'eg'" class="segment-items mx-auto px-1 pt-1 p-0" style="min-width:70px;">
          <div class="row" style="cursor:pointer; font-size:small;" @click="tabActual=index; listarEvento(evento_m.evt_id);">
            <div class="col-12 text-center m-0 px-1">
              <!-- <fa v-if="tabActual==index" :icon="['fad', 'bell-on']" class="h5 fa-fw mb-1 text-primary"></fa> -->
              <fa v-if="evento_m.evt_estado == 1" :icon="['fad', 'bell-on']" class="h5 fa-fw mb-1 text-danger"></fa>
              <fa v-if="evento_m.evt_estado == 2" :icon="['fad', 'bell-on']" class="h5 fa-fw mb-1 text-warning"></fa>
              <fa v-if="evento_m.evt_estado == 3" :icon="['fad', 'bell-on']" class="h5 fa-fw mb-1 text-primary"></fa>
              <fa v-if="evento_m.evt_estado == 4" :icon="['fad', 'bell-on']" class="h5 fa-fw mb-1 text-success"></fa>
            </div>
            <div class="col-12 text-center m-0 px-1">
              <ion-label v-if="tabActual==index" class="text-primary font-weight-bold">Ticket {{evento_m.evt_id}}</ion-label>
              <ion-label v-else class="text-secondary">Ticket {{evento_m.evt_id}}</ion-label>
            </div>
          </div>
        </div>
      </div>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-grid v-if="cargando" class="ion-text-center ion-margin-top ion-padding-top">
      <ion-row class="ion-justify-content-center ion-margin-top ion-padding-top">
        <ion-col size="12">
          <ion-spinner name="lines" style="width:80px; height:80px;"></ion-spinner>
        </ion-col>
        <ion-col size="12">
          <ion-label color="dark">CARGANDO...</ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div v-else>
      <div v-if="!revisar && !finalizar && !cerrarEvento && !analizar" class="container-fluid mt-3">
        <div class="row">
          <div class="col pt-2">
            Tipo de evento:
          </div>
          <div class="col text-right pb-2">
            <ion-button v-if="eventoProp.estado_actual.hev_estado in [1,2] && !cambiandoTipo" @click="listarTiposEvento(); cambiandoTipo=true;" color="primary" shape="round" size="small">
                <ion-label>CAMBIAR</ion-label>
            </ion-button>
          </div>
          <div v-if="cambiandoTipo" class="col-12 mb-5 rounded pb-3 border border-secondary">
            <div v-if="tiposEvento.length > 0" class="row mt-3">
              <div class="col-12 text-secondary">
                Origen del evento
              </div>
              <div class="col-12">
                <ion-item>
                  <ion-select fill="solid" interface="action-sheet" ok-text="ACEPTAR" cancel-text="CANCELAR" placeholder="Seleccione.." @ionChange="listarSubTiposEvento(tipoEvento, 1);" v-model="tipoEvento">
                    <ion-select-option :key ="index" v-for="(tipo, index) in tiposEvento" :value="tipo" v-text="tipo.tev_tipo"></ion-select-option>
                  </ion-select>
                </ion-item>
              </div>
            </div>

            <div v-if="subTiposEvento1.length > 0" class="row mt-3">
              <div class="col-12 text-secondary">
                Subcategoría 1
              </div>
              <div class="col-12">
                <ion-item>
                  <ion-select fill="solid" interface="action-sheet" cancel-text="CANCELAR" ok-text="ACEPTAR" placeholder="Seleccione.." @ionChange="listarSubTiposEvento(subTipoEvento1, 2);" v-model="subTipoEvento1">
                    <ion-select-option :key ="index" v-for="(tipo, index) in subTiposEvento1" :value="tipo" v-text="tipo.tev_tipo"></ion-select-option>
                  </ion-select>
                </ion-item>
              </div>
            </div>

            <div v-if="subTiposEvento2.length > 0" class="row mt-3">
              <div class="col-12 text-secondary">
                Subcategoría 2
              </div>
              <div class="col-12">
                <ion-item>
                  <ion-select fill="solid" interface="action-sheet" cancel-text="CANCELAR" ok-text="ACEPTAR" placeholder="Seleccione.." @ionChange="nuevoTipoEvento=subTipoEvento2" v-model="subTipoEvento2">
                    <ion-select-option :key ="index" v-for="(tipo, index) in subTiposEvento2" :value="tipo" v-text="tipo.tev_tipo"></ion-select-option>
                  </ion-select>
                </ion-item>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col text-center"><ion-button @click="cambiandoTipo=false;" color="danger" shape="round">CANCELAR</ion-button></div>
              <div class="col text-center"><ion-button @click="cambiarTipoEvento();" :disabled="nuevoTipoEvento == ''" color="success" shape="round">REGISTRAR</ion-button></div>
            </div>
          </div>
          <div v-else class="col-12">
            <div class="alert alert-secondary pb-0 px-2 pt-2">
              <h6 v-for="(tipo, index) in evento.tipo" :key="index">{{index+1}} - {{tipo.tev_tipo}}</h6>
            </div>
          </div>
        </div>
        <div v-if="evento.estado_actual.hev_observacion" class="row">
          <div class="col">
            Ultima observación:
            <div class="alert alert-secondary pb-0 px-2 pt-2">
              <h6>{{ evento.estado_actual.hev_observacion }}</h6>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            Evento reportado por:
            <div class="alert alert-secondary pb-0 px-2 pt-2">
              <h6>{{ evento.usuario.usr_nombres+' '+evento.usuario.usr_apellido_p+' '+evento.usuario.usr_apellido_m}}</h6>
              <h6>Telefono: +56 {{evento.usuario.usr_telefono}} <button @click="copiaTexto('+56'+evento.usuario.usr_telefono);" class="btn btn-sm btn-outline-primary rounded rounded-pill" style="height: 23px; padding-top: 0px;">copiar</button></h6>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            Empresa/Sucursal:
            <div class="alert alert-secondary pb-0 px-2 pt-2">
              <h6 v-if="evento.usuario.emp_nombre != null">{{ evento.usuario.emp_nombre}}</h6>
              <h6 v-if="evento.usuario.suc_nombre != null && evento.usuario.emp_nombre != evento.usuario.suc_nombre">{{ evento.usuario.suc_nombre}}</h6>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            Estados del evento:
            <div v-for="(estado, index) in evento.estados" :key="index+'est'" class="alert pb-0 px-2 pt-2" 
              :class="estado.hev_estado == 1 ? 'alert-danger':estado.hev_estado == 2 ? 'alert-warning':estado.hev_estado == 3 ? 'alert-primary':'alert-success'">
              <div class="container-fluid p-0">
                <div class="row">
                  <div class="col-5">
                    <h6>Estado</h6>
                  </div>
                  <div class="col">
                    <h6>: {{ estado.tpe_estado }} <span class="font-weight-bold" style="font-size:small;" v-if="index==0">(Estado actual)</span></h6>
                  </div>
                </div>
                <div class="row">
                  <div class="col-5">
                    <h6>Fecha</h6>
                  </div>
                  <div class="col">
                    <h6>: {{ 
                      estado.hev_fecha_hora.split(' ')[0].split('-')[2] + '/' +
                      estado.hev_fecha_hora.split(' ')[0].split('-')[1] + '/' +
                      estado.hev_fecha_hora.split(' ')[0].split('-')[0] + ' '
                      }}</h6>
                  </div>
                </div>
                <div class="row">
                  <div class="col-5">
                    <h6>Hora</h6>
                  </div>
                  <div class="col">
                    <h6>: {{ 
                      estado.hev_fecha_hora.split(' ')[1].split(':')[0] + ':' +
                      estado.hev_fecha_hora.split(' ')[1].split(':')[1] 
                      }}</h6>
                  </div>
                </div>
                <div v-if="estado.hev_estado==2" class="row">
                  <div class="col-5">
                    <h6>Tiempo estimado</h6>
                  </div>
                  <div class="col">
                    <h6 v-if="estado.hev_tiempo_estimado>=60">: {{ estado.hev_tiempo_estimado/60 }} Horas.</h6>
                    <h6 v-else>: {{ estado.hev_tiempo_estimado}} Minutos.</h6>
                  </div>
                </div>
                <div v-if="estado.hev_estado==2" class="row mt-2">
                  <div class="col-12">
                    <h6>Soporte</h6>
                  </div>
                  <div class="col-12 pl-4 text-muted">
                    <h6>{{ estado.hev_nombres_soporte +' '+estado.hev_apellido_p_soporte +' '+estado.hev_apellido_m_soporte }}</h6>
                  </div>
                </div>
                <div v-if="estado.hev_observacion && estado.hev_estado!=3" class="row">
                  <div class="col-12">
                    <h6>Observación</h6>
                  </div>
                  <div class="col-12 pl-4 text-muted">
                    <h6>{{ estado.hev_observacion }}</h6>
                  </div>
                </div>
                <div v-if="estado.hev_estado==3" class="row">
                  <div class="col-12">
                    <h6>Acciones inmediatas</h6>
                  </div>
                  <div class="col-12 pl-4 text-muted">
                    <h6>{{ estado.hev_observacion }}</h6>
                  </div>
                </div>
                <div v-if="estado.hev_estado==5 && estado.hev_analisis != ''" class="row">
                  <div class="col-12">
                    <h6>Analisis de la causa</h6>
                  </div>
                  <div class="col-12 pl-4 text-muted">
                    <h6>{{ estado.hev_analisis.aev_analisis_causa}}</h6>
                  </div>
                </div>
                <div v-if="estado.hev_estado==5 && estado.hev_analisis != ''" class="row">
                  <div class="col-12">
                    <h6>Acciones correctiva</h6>
                  </div>
                  <div class="col-12 pl-4 text-muted">
                    <h6>{{ estado.hev_analisis.aev_acciones_correctivas}}</h6>
                  </div>
                </div>
                <div v-if="estado.hev_estado==5 && estado.hev_analisis != ''" class="row">
                  <div class="col-12">
                    <h6>Analizado por</h6>
                  </div>
                  <div class="col-12 pl-4 text-muted">
                    <h6>{{ estado.hev_analisis.usr_nombres+' '+estado.hev_analisis.usr_apellido_p+' '+estado.hev_analisis.usr_apellido_m}}</h6>
                  </div>
                </div>
                <div v-if="estado.fotos.length > 0" class="row mb-2">
                  <div class="col-12">
                    <h6>Fotos/Imagenes</h6>
                  </div>
                  <div class="col text-center" v-for="(foto, index) in estado.fotos" :key="index+'foto'">
                    <ion-thumbnail @click="muestraModalImagen(foto.foe_foto)" style="cursor:pointer;">
                      <img :src="foto.foe_foto">
                    </ion-thumbnail>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="propEvento.grupo == 1 && (eventoProp.estado_actual.hev_estado == 1 || eventoProp.estado_actual.hev_estado == 2 || eventoProp.estado_actual.hev_estado == 4)" 
          class="row justify-content-center mb-3">
          <div class="col-md-8 col-sm-12">
            <ion-button @click="muestraAlertExcluir()" color="danger" shape="round" expand="block">
                <ion-label>EXCLUIR EVENTO DEL GRUPO</ion-label>
            </ion-button>
          </div>
        </div>
      </div>

      <div v-if="revisar" class="container-fluid mt-4">
        <div class="row">
          <div class="col">
            Ingresa una observación(opcional):
            <textarea v-model="comentario" class="form-control" style="height:100px!important;" placeholder="Ingrese un comentario..."></textarea>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            Tiempo estimado:
          </div>
          <div class="col-12">
            <ion-list>
              <ion-radio-group :value="tipoTiempo" v-model="tipoTiempo">
                <ion-list-header>
                  <ion-label>Horas / Minutos</ion-label>
                </ion-list-header>

                <ion-item>
                  <ion-label>Horas</ion-label>
                  <ion-radio slot="start" value="Horas" ></ion-radio>
                </ion-item>

                <ion-item>
                  <ion-label>Minutos</ion-label>
                  <ion-radio slot="start" value="Minutos" ></ion-radio>
                </ion-item>
                
              </ion-radio-group>
              <ion-item>
                <ion-input v-model="tiempoEstimado" placeholder="Ingresa tiempo" color="dark" type="number"></ion-input>
                <ion-label>{{tipoTiempo}}</ion-label>
              </ion-item>
            </ion-list>
          </div>
        </div>
      </div>

      <div v-if="finalizar" class="container-fluid mt-4">
        <div class="row mt-3">
          <div class="col">
            Ingresa las acciones inmediatas:
            <textarea v-model="accionesInmediatas" class="form-control" style="height:100px!important;" 
            placeholder="Ej. Se arregló opción en sistema. (Comentario de la solución del problema.)"></textarea>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12 d-flex align-items-center">
            <ion-toggle class="pl-0" v-model="incluyeImagenes" @ionChange="imagenesEvento=[];imagenes=[];" color="secondary"></ion-toggle> 
            <span class="text-secondary">Incluir imagenes</span>
            <span v-if="incluyeImagenes" class=" ml-3 text-success">SÍ</span>
            <span v-else class="ml-3 text-danger">NO</span>
          </div>
        </div>

        <div v-if="incluyeImagenes" class="row mt-2 justify-content-center">
          <div class="col-6 text-center px-1">
            <ion-button @click="subirImagen()" color="primary" shape="round" fill="outline"><fa icon="image-polaroid" type="fad" class="fa-fw mr-1"></fa>SUBIR FOTO</ion-button>
          </div>
          <div v-if="esMovil" class="col-6 text-center px-0">
            <ion-button @click="tomarImagen()" color="primary" shape="round" fill="outline"><fa icon="camera" type="fad" class="fa-fw mr-1"></fa>TOMAR FOTO</ion-button>
          </div>
          <div class="col-12 text-center">
            <!-- ACA IRIAN LAS FOTOS -->
            <div v-if="imagenes.length>0" class="row mb-2 justify-content-center">
              <div class="col-3 mx-1 mt-2 pb-3 shadow-sm" :id="'foto'+index" :key="foto" v-for="(foto, index) in imagenes">
                <div class="cursor-pointer" @click.stop.prevent="eliminaFoto('foto'+index, index);">
                  <fa icon="times-square" type="fas" class="my-2 float-left text-danger"></fa>
                </div>
                <img :src="foto.webviewPath">
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12 text-center text-muted">
            Al confirmar la finalización estará confirmando que el evento fue resuelto, y se enviará una alerta al emisor del evento.
          </div>
        </div>
      </div>

      <div v-if="analizar" class="container-fluid mt-4">
        <div class="row mt-2" v-if="propEvento.tev_prioridad == 1">
          <div class="col">
            Ingresa analisis de las causas del incidente:
            <textarea v-model="analisisCausa" class="form-control border border-secondary" style="height:100px!important;" 
            placeholder="Ej. Falla en servicio de datos. Problema en acceso edificio. Falta de capacitacion."></textarea>
          </div>
        </div>
        <div class="row mt-2" v-if="propEvento.tev_prioridad == 1">
          <div class="col">
            Ingresa las acciones correctivas:
            <textarea v-model="accionesCorrectivas" class="form-control border border-secondary" style="height:100px!important;" 
            placeholder="Ej. Se capacitó al personal. Se mejoró seguridad perimetral."></textarea>
          </div>
        </div>
      </div>

      <div v-if="cerrarEvento" class="container-fluid mt-4">
        <div class="row mt-2">
          <div class="col-12">
            Tiempo estimado de resoluación:
          </div>
          <div class="col-12">
            <ion-list lines="full">
              <ion-radio-group :value="tipoTiempo" v-model="tipoTiempo">
                <ion-list-header>
                  <ion-label>Horas / Minutos</ion-label>
                </ion-list-header>

                <ion-item>
                  <ion-label>Horas</ion-label>
                  <ion-radio slot="start" value="Horas" ></ion-radio>
                </ion-item>

                <ion-item>
                  <ion-label>Minutos</ion-label>
                  <ion-radio slot="start" value="Minutos" ></ion-radio>
                </ion-item>
                
              </ion-radio-group>
              <ion-item>
                <ion-input v-model="tiempoEstimado" placeholder="Ingresa tiempo" color="dark" type="number"></ion-input>
                <ion-label>{{tipoTiempo}}</ion-label>
              </ion-item>
            </ion-list>
          </div>
        </div>
        
        <div class="row mt-3">
          <div class="col">
            Ingresa las acciones inmediatas:
            <textarea v-model="accionesInmediatas" class="form-control" style="height:100px!important;" 
            placeholder="Ej. Se arregló opción en sistema. (Comentario de la solución del problema.)"></textarea>
          </div>
        </div>
        <div class="row mt-4 mb-4">
          <div class="col-12 text-center text-muted">
            Al confirmar estas indicando el evento fue abordado.
          </div>
        </div>
      </div>

    </div>

  </ion-content>

  <ion-footer>
    <ion-grid v-if="tipoUsuario != 6">
      <ion-row v-if="!revisar && !finalizar && !analizar">
        <ion-col>
            <ion-button v-if="eventoProp.estado_actual.hev_estado == 1" @click="revisar=true;" color="warning" shape="round" expand="block">
                <ion-label v-if="propEvento.grupo == 1">REVISAR EVENTO MASIVO</ion-label>
                <ion-label v-else>REVISAR EVENTO</ion-label>
            </ion-button>
            <ion-button v-if="eventoProp.estado_actual.hev_estado == 2" @click="finalizar=true;" 
                :disabled="eventoProp.estado_actual.hev_rut_soporte != rutUsuario && tipoUsuario != 1" color="success" shape="round" expand="block">
                <ion-label v-if="propEvento.grupo == 1">FINALIZAR EVENTO MASIVO</ion-label>
                <ion-label v-else>FINALIZAR EVENTO</ion-label>
            </ion-button>
            <ion-button v-if="propEvento.tev_prioridad == 1 && (eventoProp.estado_actual.hev_estado == 3 || eventoProp.estado_actual.hev_estado == 4)" @click="analizar=true;" color="success" shape="round" expand="block">
                <ion-label>ACCIONES CORRECTIVAS</ion-label>
            </ion-button>
        </ion-col>
      </ion-row>
      <ion-row v-if="revisar">
        <ion-col>
            <ion-button @click="cerrarModal({recargar: true})" color="danger" shape="round" expand="block">
                <ion-label>CANCELAR</ion-label>
            </ion-button>
        </ion-col>
        <ion-col>
            <ion-button :disabled="tiempoEstimado == null || tiempoEstimado == ''" @click="cambiarEstadoRevisando();" color="success" shape="round" expand="block">
                <ion-label>CONFIRMAR</ion-label>
            </ion-button>
        </ion-col>
      </ion-row>
      <ion-row v-if="finalizar">
        <ion-col>
            <ion-button @click="cerrarModal({recargar: true})" color="danger" shape="round" expand="block">
                <ion-label>CANCELAR</ion-label>
            </ion-button>
        </ion-col>
        <ion-col>
            <ion-button @click="cambiarEstadoResuelto();" color="success" shape="round" expand="block" :disabled="accionesInmediatas == ''">
                <ion-label>CONFIRMAR</ion-label>
            </ion-button>
        </ion-col>
      </ion-row>
      <ion-row v-if="analizar">
        <ion-col>
            <ion-button @click="cerrarModal({recargar: true})" color="danger" shape="round" expand="block">
                <ion-label>CANCELAR</ion-label>
            </ion-button>
        </ion-col>
        <ion-col>
            <ion-button @click="cambiarEstadoAnalizado();" color="success" shape="round" expand="block" :disabled="analisisCausa == '' || accionesCorrectivas == ''">
                <ion-label>REGISTRAR</ion-label>
            </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid v-else>
      <ion-row>
        <ion-col>
          <ion-button v-if="eventoProp.estado_actual.hev_estado == 1" @click="cerrarEvento=true;" color="warning" shape="round" expand="block">
              <ion-label>FINALIZAR EVENTO</ion-label>
          </ion-button>
          <ion-button v-if="cerrarEvento" @click="finalizarEvento();" color="success" shape="round" expand="block" :disabled="accionesInmediatas=='' || tiempoEstimado==''">
              <ion-label>CONFIRMAR</ion-label>
          </ion-button>
          <ion-button v-if="eventoProp.estado_actual.hev_estado == 4" @click="cerrarModal();" color="danger" shape="round" expand="block">
              <ion-label>CERRAR</ion-label>
          </ion-button>
        </ion-col>
      </ion-row>   
    </ion-grid> 
  </ion-footer>
</template>

<script>
import { modalController, toastController, IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow,IonGrid, IonSpinner, IonLabel, IonRadio, IonRadioGroup, IonList, IonItem, IonListHeader, IonInput, IonThumbnail, alertController, IonSelect, IonSelectOption, IonToggle} from '@ionic/vue';
import { defineComponent } from 'vue';
import { addIcons        } from 'ionicons';
import { arrowBackOutline, trashOutline, settingsOutline} from 'ionicons/icons';
import { Preferences     } from '@capacitor/preferences';
import { Clipboard       } from '@capacitor/clipboard';
import { tomarFoto, subirFoto } from '@/plugins/usarCamara';


import * as $     from "jquery";
import axios      from 'axios';
import rutaBase   from '@/plugins/variables';
import mImagen    from './ModalImagen.vue';
//import ModalNuevoTipoEvento from './ModalNuevoTipoEvento.vue';

export default defineComponent({
  name: 'ModalEvento',
  props: {
    propEvento  : Object,
    modal       : Object
  },
  components: { IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow, IonGrid, IonSpinner, IonLabel, IonRadio, IonRadioGroup, IonList, IonItem, IonListHeader, IonInput, IonThumbnail, IonSelect, IonSelectOption, IonToggle},
  
  data(){
    return {
      cargando              : true,
      usuarioOrigen         : [],
      eventoProp            : null,
      evento                : {},
      rutUsuario            : null,
      tipoUsuario           : null,
      revisar               : false,
      finalizar             : false,
      analizar              : false,
      tipoTiempo            : 'Minutos',
      tiempoEstimado        : '',
      analisisCausa         : '',
      accionesInmediatas    : '',
      accionesCorrectivas   : '',
      comentario            : '',
      ModalImagen           : null,
      tabActual             : 0,
      cerrarEvento          : false,
      cambiandoTipo         : false,
      tiposEvento           : [],
      subTiposEvento1       : [],
      subTiposEvento2       : [],
      nuevoTipoEvento       : '',

      //variables imagenes
      incluyeImagenes       : false,
      imagenes              : [],
      imagenesEvento        : [],
    }
  },
  created() {
    this.eventoProp = JSON.parse(JSON.stringify(this.propEvento));
    addIcons({
      'arrow-back-outline'  : arrowBackOutline,
      'trash-outline'       : trashOutline,
      'settings-outline'    : settingsOutline
    });
  },
  mounted(){
    this.datosUsuario();
    if(this.eventoProp.grupo == 0){
      this.listarEvento(this.eventoProp.evt_id);
    }
    else{
      this.listarEventosGrupo();
    }
    
  },
  methods:{
    async copiaTexto(texto){
      await Clipboard.write({
        string: texto
      });
    },

    async datosUsuario(){
      this.rutUsuario  = (await Preferences.get({ key: 'rut' })).value;
      this.tipoUsuario = (await Preferences.get({ key: 'tipo_usuario' })).value;
    },

    async listarEvento(idEvento){
      this.cargando = true;
      const dato    = new URLSearchParams();
      dato.append('id_evento', idEvento);
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/soporte/listarEvento', dato, headers).then( resp => {
        this.evento = '';
        this.evento = resp.data.evento;
        this.eventoProp = JSON.parse(JSON.stringify(this.evento));
        this.cargando = false;
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async listarEventosGrupo(){
      this.cargando = true;
      const dato    = new URLSearchParams();
      dato.append('id_grupo', this.eventoProp.id_grupo);
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/soporte/listarEventosGrupo', dato, headers).then( resp => {
        this.eventosGrupo = resp.data.eventos;
        this.listarEvento(this.eventosGrupo[0].evt_id);
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async listarTiposEvento(){
      this.subTipoEvento1  = this.subTipoEvento2 = '';
      this.tiposEvento     = [];
      this.subTiposEvento1 = [];
      this.subTiposEvento2 = [];
      this.cargando        = true;
      const token          = await Preferences.get({ key: 'token_auth' });
      const headers        = { headers: { 'Authorization': `${token.value}` } };
      const data           = new URLSearchParams();
      data.append('id_empresa', this.evento.usuario.usr_empresa);
      axios.post(rutaBase+'/soporte/listarTiposEventoEmpresa', data, headers).then( resp => {
        /* if(resp.status == 203) { cerrarSesion(); }
        else{ */
          this.tiposEvento = resp.data;
          this.cargando = false;
        //}
      }).catch(() =>{
        console.log("ERROR");
        this.cargando = false;
      });
    },

    async listarSubTiposEvento(tipoEvento, tipoHijo){
      this.nuevoTipoEvento = '';
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const data        = new URLSearchParams();
      data.append('id_tipo', tipoEvento.tev_id);
      axios.post(rutaBase+'/soporte/listarSubTiposEvento', data, headers).then( resp => {
        /* if(resp.status == 203) { cerrarSesion(); }
        else{ */
        if(tipoHijo == 1) {
          this.subTiposEvento1 = resp.data; 
          this.subTiposEvento2 = []; 
          if(this.subTiposEvento1.length == 0){
            this.nuevoTipoEvento = tipoEvento;
          }
        }
        if(tipoHijo == 2) {
          this.subTiposEvento2 = resp.data;
          if(this.subTiposEvento2.length == 0){
            this.nuevoTipoEvento = tipoEvento;
          }
        }
        this.cargando = false;
        //}
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async cambiarTipoEvento(){
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const data        = new URLSearchParams();
      data.append('id_evento' , this.eventoProp.evt_id);
      data.append('id_tipo'   , this.nuevoTipoEvento.tev_id);
      axios.post(rutaBase+'/soporte/cambiarTipoEvento', data, headers).then( resp => {
        if(resp.data.key == 1){
          this.listarEvento(this.eventoProp.evt_id);
          this.cambiandoTipo = false;
          this.nuevoTipoEvento = '';
        }
        else{
          this.muestraToast('ERROR AL CAMBIAR EL TIPO.');
        }
        this.cargando = false;
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async muestraAlertExcluir() {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: 'EXCLUIR EVENTO',
          message: '¿DESEA EXCLUIR EVENTO DE LA FALLA MASIVA?',
          buttons: [
            {
              text: 'CANCELAR',
              role: 'cancel',
              cssClass: 'secondary',
              handler: blah => {
                console.log('Confirm Cancel:', blah)
              },
            },
            {
              text: 'EXCLUIR',
              role: 'ok',
              cssClass: 'primary',
              handler: () => {
                this.excluirEventoGrupo();
              },
            },
          ],
        });
      return alert.present();
    },

    async excluirEventoGrupo(){
      this.cargando = true;
      const dato    = new URLSearchParams();
      dato.append('id_evento', this.evento.evt_id);
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/soporte/excluirEventoGrupo', dato, headers).then( resp => {
        if(resp.data.key == 1){
          this.muestraToast('EVENTO EXCLUIDO.');
          this.listarEventosGrupo();
        }
        else {
          this.cargando = false;
          this.muestraToast('ERROR AL EXCLUIR EVENTO.');
        }
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async muestraAlertEliminar() {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: 'ELIMINAR EVENTO',
          message: '¿Desea eliminar el evento?',
          buttons: [
            {
              text: 'CANCELAR',
              role: 'cancel',
              cssClass: 'secondary',
              handler: blah => {
                console.log('Confirm Cancel:', blah)
              },
            },
            {
              text: 'ELIMINAR',
              role: 'ok',
              cssClass: 'primary',
              handler: () => {
                this.eliminarEvento();
              },
            },
          ],
        });
      return alert.present();
    },

    async eliminarEvento(){
      this.cargando = true;
      const dato  = new URLSearchParams();
      dato.append('id_evento'       , this.propEvento.evt_id);
      dato.append('grupo'           , this.propEvento.grupo);
      if(this.propEvento.grupo == 1){
        dato.append('id_grupo'      , this.propEvento.id_grupo);
      }
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/soporte/eliminarEvento', dato, headers).then( resp => {
        if(resp.data.key == 1){
          this.cerrarModal({recargar: true});
        }
        else{
          this.muestraToast(resp.data.msj);
        }
        this.cargando = false;
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async cambiarEstadoRevisando(){
      this.cargando = true;
      let tiempo    = 0;
      if(this.tipoTiempo == "Horas"){
        tiempo = this.tiempoEstimado*60;
      }else{
        tiempo = this.tiempoEstimado;
      }
      const dato  = new URLSearchParams();
      dato.append('id_evento'       , this.eventoProp.evt_id);
      dato.append('rut_soporte'     , this.rutUsuario);
      dato.append('tiempo_estimado' , tiempo);
      dato.append('comentario'      , this.comentario);
      dato.append('grupo'           , this.propEvento.grupo);
      if(this.propEvento.grupo == 1){
        dato.append('id_grupo'      , this.propEvento.id_grupo);
      }
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/soporte/cambiarEstadoRevisando', dato, headers).then( resp => {
        this.cargando = false;
        if(resp.data.key == 1){
          this.revisar        = false;
          this.comentario     = '';
          this.tiempoEstimado = '';
          this.muestraToast('EVENTO ACTUALIZADO.');
          this.cerrarModal({recargar: true});
        }
        else{
          this.muestraToast(resp.data.msj);
          this.revisar        = false;
          this.comentario     = '';
          this.tiempoEstimado = '';
          this.listarEvento(this.eventoProp.evt_id);
        }
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async cambiarEstadoResuelto(){
      this.cargando = true;
      await this.ajustaFotosCamara();
      const dato    = new URLSearchParams();
      dato.append('id_evento'             , this.eventoProp.evt_id);
      dato.append('prioridad'             , this.eventoProp.tev_prioridad);
      dato.append('acciones_inmediatas'   , this.accionesInmediatas);
      dato.append('grupo'                 , this.propEvento.grupo);
      dato.append('imagenes'              , JSON.stringify(this.imagenesEvento));
      if(this.propEvento.grupo == 1){
        dato.append('id_grupo'      , this.propEvento.id_grupo);
      }
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/soporte/cambiarEstadoResuelto', dato, headers).then( resp => {
        this.cargando = false;
        if(resp.data.key == 1){
          this.finalizar          = false;
          this.accionesInmediatas = '';
          this.muestraToast('EVENTO ACTUALIZADO.');
          this.cerrarModal({recargar: true});
        }
        else{
          this.muestraToast('ERROR AL REGISTRAR LOS DATOS.');
        }
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async finalizarEvento(){
      this.cargando = true;
      let tiempo    = 0;
      if(this.tipoTiempo == "Horas"){
        tiempo = this.tiempoEstimado*60;
      }else{
        tiempo = this.tiempoEstimado;
      }
      const dato    = new URLSearchParams();
      dato.append('id_evento'             , this.eventoProp.evt_id);
      dato.append('rut_soporte'           , this.rutUsuario);
      dato.append('tiempo_estimado'       , tiempo);
      dato.append('prioridad'             , this.eventoProp.tev_prioridad);
      dato.append('acciones_inmediatas'   , this.accionesInmediatas);
      dato.append('grupo'                 , this.propEvento.grupo);
      if(this.propEvento.grupo == 1){
        dato.append('id_grupo'      , this.propEvento.id_grupo);
      }
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/soporte/finalizarEvento', dato, headers).then( resp => {
        this.cargando = false;
        if(resp.data.key == 1){
          this.accionesInmediatas = '';
          this.muestraToast('EVENTO ACTUALIZADO.');
          this.cerrarModal({recargar: true});
        }
        else{
          this.muestraToast('ERROR AL REGISTRAR LOS DATOS.');
        }
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async cambiarEstadoAnalizado(){
      this.cargando = true;
      const dato    = new URLSearchParams();
      dato.append('id_evento'             , this.eventoProp.evt_id);
      dato.append('rut_soporte'           , this.rutUsuario);
      dato.append('analisis_causa'        , this.analisisCausa);
      dato.append('acciones_correctivas'  , this.accionesCorrectivas);
      dato.append('grupo'                 , this.propEvento.grupo);
      if(this.propEvento.grupo == 1){
        dato.append('id_grupo'      , this.propEvento.id_grupo);
      }
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/soporte/cambiarEstadoAnalizado', dato, headers).then( resp => {
        this.cargando = false;
        if(resp.data.key == 1){
          this.analisisCausa        = '';
          this.accionesCorrectivas  = '';
          this.muestraToast('EVENTO ACTUALIZADO.');
          this.cerrarModal({recargar: true});
        }
        else{
          this.muestraToast('ERROR AL REGISTRAR LOS DATOS.');
        }
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async muestraModalImagen(imagen){
      this.modalImagen = await modalController
        .create({
          component       : mImagen,
          componentProps  : {
            imagen        : imagen,
            modal         : this.modalImagen
          }
        });
      this.modalImagen.present();
      const modalResponse = await this.modalImagen.onDidDismiss();
      modalResponse.data && this.modalCloseHandler({...modalResponse.data})
    },

    modalCloseHandler(_value) {
      const datos = _value;
      console.log(datos);
    },

    formateaNumero(numero){
      return new Intl.NumberFormat("de-DE").format(numero)
    },

    async cerrarModal(dato=null){
      modalController.dismiss(dato);
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    },

    /*************************************/
    /* FUNCIONES PARA MANEJO DE IMAGENES */
    /*************************************/
    async tomarImagen(){
      const foto = await tomarFoto();
      this.imagenes.push(foto);
    },

    async subirImagen(){
      const foto = await subirFoto();
      this.imagenes.push(foto);
    },

    async resizeImg(base64) {
      const ancho = 720;
      const alto  = 1280;
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      const deferred = $.Deferred();
      let escala = 0;
      $("<img>").attr("src", base64).on("load", function() {
          let width, height;
          if(this.width < this.height){
            width   = ancho;
            height  = alto;
          }else{
            width   = alto;
            height  = ancho;
          }
          if(width/this.width < height/this.height){
            escala = width/this.width;
          }else{
            escala = height/this.height;
          }
          canvas.width  = this.width*escala;
          canvas.height = this.height*escala;

          context.scale(escala, escala);
          context.drawImage(this, 0, 0);
          deferred.resolve(canvas.toDataURL());
      });
      return deferred.promise();
    },

    eliminaFoto(id,indice){
      console.log(id)
      console.log(indice)
      this.idImagenBorrar = id;
      this.indiceImagenBorrar = indice;
      this.muestraAlertEliminacion();
    },

    async muestraAlertEliminacion() {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: 'Confirmar',
          message: '¿DESEA ELIMINAR LA IMAGEN SELECCIONADA?',
          buttons: [
            {
              text: 'CANCELAR',
              handler: () => {
                this.idImagenBorrar     = '';
                this.indiceImagenBorrar = '';
              },
            },
            {
              text: 'ACEPTAR',
              handler: () => {
                this.imagenes.splice(this.indiceImagenBorrar, 1)
                $("#"+this.idImagenBorrar).remove();
                this.idImagenBorrar     = '';
                this.indiceImagenBorrar = '';
              },
            },
          ],
        });
      return alert.present();
    },

    async ajustaFotosCamara(){
      const fotosCamara = [];
      this.imagenes.forEach( function(valor) {
        fotosCamara.push(valor.webviewPath)
      });
      for(let i=0;i<fotosCamara.length;i++){
        await this.resizeImg(fotosCamara[i]).then(img => {
          this.imagenesEvento.push(img);
        });
      }
    }

  }
});
</script>

<style scoped>
.primary{
  color         : #3880ff;
}

.rounded-border {
  border        :2px solid black;
  color         :black; 
  padding       :6px; 
  border-radius :15px; 
  margin-right  :2px;
}

.cards {
  min-height      : 150px;
  border-radius   : 15px; 
  margin          : 0;
  /* background-color: white !important; */
  border          : 2px solid black !important;
}

.fondo{
  /* background-color: white !important; */
  height: 100% !important;
}

.segment-tabs {
    display    : flex;
    overflow-x : scroll;
    min-height : 70px;
}

.segment-item {
    display   : inline-block !important;
    min-width : 250px !important;
    /* width: auto !important; */
}

.form-control{
  background-color  : transparent !important;
  color             : unset !important;
  border-color      : #6c757d !important;
  border            : 1px solid #dee2e6 !important;
    border-top-color    : rgb(222, 226, 230);
    border-right-color  : rgb(222, 226, 230);
    border-bottom-color : rgb(222, 226, 230);
    border-left-color   : rgb(222, 226, 230);
}
</style>